import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PaymentPage = () => {
  const location = useLocation();
  const { checkoutId, shopperResultUrl , integrity } = location.state || {};

  

  useEffect(() => {
    if (!checkoutId) return;
    const script = document.createElement('script');
    script.src = `https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
    script.async = true;
    script.integrity = `${integrity}`;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [checkoutId , integrity]);

  if (!checkoutId) {
    return <div>Error: Checkout ID is missing</div>;
  }

  return (
    <div style={{height: "100vh" ,display: "flex" , alignItems: "center" ,justifyContent: "center" ,flexDirection: "column" }}>
      <h2>Complete your payment</h2>
      <form
        action={shopperResultUrl}
        className="paymentWidgets"
        data-brands="VISA MASTER AMEX"
      ></form>
    </div>
  );
};

export default PaymentPage;
